import styled from "styled-components";

export const MainTemplate = styled.div`
  height: 100vh;
  width: 100%;
  display: grid;
  grid-template-columns: 256px 1fr;
  grid-template-rows: 90px 1fr;
  margin: 0;
  padding: 0;
`;

export const LogoWrapper = styled.div`
  position: relative;
  height: 9rem;
`;

export const Logo = styled.img`
  max-height: 100%;
  max-width: 11rem;
  margin-left: 2.5rem;
  margin-top: 0.75rem;
`;

export const Sidebar = styled.aside`
  background-color: #eeeeee;
  grid-row: 1 / 3;
  box-shadow: 10px 0 10px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;

export const Main = styled.main`
  grid-row: 1 /-1;
  overflow-y: auto;
`;

export const Content = styled.section`
  padding: 2.4rem;
  margin: 2.4rem;
  min-height: 50rem;
  max-width: 140rem;
`;

export const VenueSelectWrapper = styled.div`
  padding: 2.5rem 0.75rem;

  .ant-select {
    width: 100%;
  }
`;
